var DesignFacade = require('../../../facade/design/design');

module.exports = {
  listeners: {},

  initialize: function (RestrictionsFactory) {
    _.bindAll(this, 'onNewSource');
    this.restrictionsFactory = RestrictionsFactory;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
  },

  refresh: function (permissions) {
    var restrictions = JSON.parse(permissions.get('restrictions') || '{}');
    var elementId = permissions.get('element_id');

    if (restrictions['source'] && restrictions['source']['list']) {
      this.listeners[elementId] || this.addListener(elementId, permissions);
    } else if (this.listeners[elementId]) {
      this.removeListener(elementId);
    }
  },

  removeListener: function (elementId) {
    this.listeners = _.omit(this.listeners, elementId);
    DesignFacade.off(elementId + '.thumb_src', this.onNewSource);
  },

  addListener: function (elementId, permissions) {
    this.listeners[elementId] = permissions;
    DesignFacade.on(elementId + '.thumb_src', this.onNewSource);
  },

  onNewSource: function (options) {
    var restrictions = JSON.parse(this.listeners[options.id].get('restrictions') || '{}');

    if (restrictions['source'] && restrictions['source']['list']) {
      var isAlreadyAdded = _(restrictions['source']['list']).find(function (data) {
        return data['thumb_src'] == options.thumb_src;
      });

      if (!isAlreadyAdded) {
        this.canvas.call('advice.show', 'source-restriction-applied');
        restrictions['source']['list'].push({
          thumb_src: options['thumb_src'],
          is_vector: options['is_vector'],
          sticker_id: options['sticker_id']
        });

        this.restrictionsFactory.setGlobalElementRestriction(
          options.id, JSON.stringify(restrictions)
        );
      }
    } else if (this.listeners[elementId]) {
      this.removeListener(elementId);
    }
  }
};
